import React from 'react';
import logo from '../../../../../assets/logo512.png';


const HomeWidget = ({app, msg}) => {
	const theapp = app;
	const ismobile = theapp.checkMobile();

	return (
		<div className="HomeWidget">
			<div className="HomeMessage">Welcome to My Widget</div>
			<img src={logo} className="HomeLogo" alt="Primus Money" />
			<div className="HomeVersionInfo" >{ismobile ? 'Mobile' : 'Desktop'}</div>
			<div className="HomeVersionInfo" >{theapp.current_version}</div>
		</div>
	);
}

export default HomeWidget;